<div class="tenantsetting-value" [formGroup]="rForm" *ngIf="setting">
    <div class="caption">{{ settingEnum }}</div>
    <div class="help-text">{{ settingCaption }}</div>

    <div class="mt15" *ngIf="setting.dataType == tsdtBoolean">
        <boolean-component [(ngModel)]="valueBoolean" name="valueBoolean" formControlName="value" [showHelpPoint]=false
            [readonly]="readonly" (valueChanged)="onBooleanChanged($event)">
        </boolean-component>
    </div>

    <div class="mt15" *ngIf="setting.dataType == tsdtHTriState">
        <tristate [(ngModel)]="valueTriState" name="valueTriState" formControlName="value" [readonly]="readonly">
        </tristate>
    </div>

    <input-component class="col-10" *ngIf="setting.dataType == tsdtLong || setting.dataType == tsdtInteger"
        [(ngModel)]="valueNumber" name="valueNumber" formControlName="value" type="number" autocomplete="off"
        [readonly]="readonly" (valueChanged)="onNumberChanged($event)">
    </input-component>

    <input-component class="col-10" *ngIf="setting.dataType == tsdtDouble" [(ngModel)]="valueNumber" name="valueNumber"
        [step]="0.1" formControlName="value" type="number" autocomplete="off" [readonly]="readonly"
        (valueChanged)="onNumberChanged($event)">
    </input-component>

    <textarea-component class="col-x" *ngIf="setting.dataType == tsdtString" [(ngModel)]="valueString"
        name="valueString" formControlName="value" (valueChanged)="onStringChanged($event)">
    </textarea-component>

    <select-component class="col-x" *ngIf="setting.dataType == tsdtEnum" [(ngModel)]="valueEnumOption" name="valueEnum"
        formControlName="value" [options]="enumOptions" [readonly]="readonly" (valueChanged)="onEnumChanged($event)">
    </select-component>

    <date-picker class="col-20" *ngIf="setting.dataType == tsdtHDate" [(ngModel)]="valueHDate" [readonly]="readonly"
        (valueChanged)="onDateChanged($event)" name="valueHDate" formControlName="value">
    </date-picker>

    <tags-chips class="col-x" *ngIf="setting.dataType == tsdtHTags" [readonly]="readonly" [(ngModel)]="valueHTags"
        (valueChanged)="onHTagsChanged($event)" name="HTags" formControlName="value">
    </tags-chips>

    <time-picker class="col-10" *ngIf="setting.dataType == tsdtHTime" [(ngModel)]="valueHTime" [readonly]="readonly"
        (valueChanged)="onHTimeChanged($event)" name="valueHTime" formControlName="value">
    </time-picker>

    <hour-picker class="col-10" *ngIf="setting.dataType == tsdtHHour" [(ngModel)]="valueHHour" [readonly]="readonly"
        (valueChanged)="onHHourChanged($event)" name="valueHHour" formControlName="value">
    </hour-picker>

    <hourinterval-picker class="col-10" *ngIf="setting.dataType == tsdtHHourInterval" [(ngModel)]="valueHHourInterval"
        [readonly]="readonly" (valueChanged)="onHHourIntervalChanged($event)" name="valueHHourInterval"
        formControlName="value">
    </hourinterval-picker>

    <hourintervals-picker class="col-30" *ngIf="setting.dataType == tsdtHHourIntervals"
        [(ngModel)]="valueHHourIntervals" [readonly]="readonly" (valueChanged)="onHHourIntervalsChanged($event)"
        name="valueHHourIntervals" formControlName="value">
    </hourintervals-picker>

    <color-picker class="backgroundColor" *ngIf="setting.dataType == tsdtColor" [(ngModel)]="valueColor"
        name="backgroundColor" formControlName="value" (valueChanged)="onColorChanged($event)">
    </color-picker>
</div>